import React from 'react';
import { Route, Routes as Switch } from 'react-router-dom';

import Routes from './Routes';

const App = () => (
  <Switch>
    <Route
      key={Routes.faq.key}
      path={Routes.faq.path}
      element={<Routes.faq.component />}
    />
    <Route
      key={Routes.oops.key}
      path={Routes.oops.path}
      element={<Routes.oops.component />}
    />
    <Route
      key={Routes.expired.key}
      path={Routes.expired.path}
      element={<Routes.expired.component />}
    />
    <Route
      key={Routes.orderSearch.key}
      path={Routes.orderSearch.path}
      element={<Routes.orderSearch.component />}
    />
    <Route
      key={Routes.main.key}
      path={Routes.main.path}
      element={<Routes.main.component />}
    />
  </Switch>
);

export default App;
